var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"theme-bg-card",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('BaseCard',{staticClass:"theme-bg-card",attrs:{"heading":"Calendar - Events"}},[_c('CalendarEvents',{staticStyle:{"background-color":"rgba(48, 64, 87, 0.1)"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }